import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouteConstants } from 'src/app/constants/route-constants';
import { CTATypes } from 'src/app/model/common.enum';
import { Router } from '@angular/router';
import {StorageService} from "../../services/storage.service";
import {UtilService} from "../../services/util.service";

@Component({
  selector: 'rch-brand-selection-page',
  templateUrl: './brand-selection-page.component.html',
  styleUrls: ['./brand-selection-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BrandSelectionPageComponent implements OnInit {
  CTATypes = CTATypes;

  constructor(private router: Router,
              private storage: StorageService,
              private utils: UtilService) {}

  ngOnInit() {
    /*const authorizationId = this.storage.getAuthorizationId();
    if (authorizationId) {
      this.router.navigate([RouteConstants.activate.self]);
    }*/
  }

  redirectTo(isShaw) {
    if (isShaw) {
      this.utils.redirectToUrl(RouteConstants.external.login.shaw, true);
    } else {
      this.utils.goToSignIn();
    }
  }

}
